module.exports = __webpack_public_path__ + "static/media/brian_blessed.6de25e14.png";